import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.195 41.024a4.528 4.528 0 0 1-5.455.122c-1.832-1.32-3.944-3.176-6.342-5.573-2.391-2.388-4.239-4.486-5.545-6.299a4.518 4.518 0 0 1 .125-5.449c1.774-2.238 4.524-5.218 8.257-8.948 3.991-3.988 7.083-6.64 9.309-7.975A6.34 6.34 0 0 1 27.804 6h8.65c1.608 0 2.396.152 3.216.59a4.2 4.2 0 0 1 1.74 1.738c.438.82.59 1.607.59 3.213v8.617a6.326 6.326 0 0 1-.865 3.194c-1.376 2.351-4.052 5.505-8.042 9.492-3.659 3.655-6.622 6.38-8.899 8.18Zm10.564-24.172a3.62 3.62 0 0 1-3.62-3.617 3.619 3.619 0 0 1 3.62-3.618c2 0 3.62 1.62 3.62 3.617a3.619 3.619 0 0 1-3.62 3.618Zm0-1.809a1.81 1.81 0 1 0 .002-3.619 1.81 1.81 0 0 0-.002 3.62Z",
    fill: "currentColor"
  }));
};

var SvgTags = styled(SvgComponent).withConfig({
  displayName: "Tags__SvgTags",
  componentId: "sc-xvpuxs-0"
})(["", " ", ""], size, color);
export default SvgTags;